import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function LegalPage({ title, kicker, children, testId }) {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: "var(--pa-bg)" }}
      data-testid={testId}
    >
      <header className="px-6 lg:px-12 py-6 border-b border-[var(--pa-border)] shrink-0">
        <Link to="/" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl text-[var(--pa-text)]">Prostho</span>
          <span className="font-serif text-2xl text-[var(--pa-gold)]">AI</span>
        </Link>
      </header>
      <main className="flex-1 px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="kicker">{kicker}</div>
          <h1
            className="font-serif text-4xl text-[var(--pa-text)] mt-2"
            data-testid={`${testId}-title`}
          >
            {title}
          </h1>
          <div className="gold-divider my-8" />
          <div className="prose prose-invert max-w-none text-[var(--pa-text)] text-sm leading-relaxed space-y-5">
            {children}
          </div>
          <div className="mt-10 text-xs text-[var(--pa-text-dim)]">
            Last updated: February 2026 · Version v1-2026-02
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
